/* eslint-disable react/require-default-props */
import { func, string } from "prop-types";

import IconButton from "../../../../shared/v2/IconButton";
import PencilSolidV6 from "../../../../shared/v2/Icomoon/Icons/PencilSolidV6";

const AddressCard = ({ streetAddress, secondaryAddress, city, state, zip, country, onEdit }) => {
  const cityState = [city, state].filter(Boolean).join(", ");
  const zipCountry = [zip, country].filter(Boolean).join(", ");

  return (
    <div className="tw-flex tw-items-start tw-gap-8d tw-p-16px tw-bg-white tw-border tw-border-solid tw-border-gray-10 tw-rounded-8px tw-mt-8px">
      <div className="tw-flex tw-flex-col tw-gap-4d tw-flex-1 tw-min-w-0 tw-break-words">
        <p className="tw-m-0 tw-text-12d tw-font-semibold tw-leading-[16px] tw-text-neutral-gray-50">
          Address
        </p>
        <div className="tw-flex tw-flex-col tw-text-14d tw-text-gray-75">
          {streetAddress && (
            <p className="tw-m-0 tw-font-semibold tw-leading-[20px]">
              {streetAddress}
              {secondaryAddress ? `, ${secondaryAddress}` : ""}
            </p>
          )}
          {/* {secondaryAddress && <p className="tw-m-0 tw-leading-[20px]">{secondaryAddress}</p>} */}
          {cityState && <p className="tw-m-0 tw-leading-[20px]">{cityState}</p>}
          {zipCountry && <p className="tw-m-0 tw-leading-[20px]">{zipCountry}</p>}
        </div>
      </div>
      <IconButton size="small" schema="tertiary" onClick={onEdit} aria-label="Edit address">
        <PencilSolidV6 size="s" />
      </IconButton>
    </div>
  );
};

AddressCard.propTypes = {
  streetAddress: string,
  secondaryAddress: string,
  city: string,
  state: string,
  zip: string,
  country: string,
  onEdit: func,
};

AddressCard.defaultProps = {
  streetAddress: "",
  secondaryAddress: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  onEdit: () => {},
};

export default AddressCard;
